import { render, staticRenderFns } from "./GradeSelector.vue?vue&type=template&id=6d5b1daf&scoped=true&"
import script from "./GradeSelector.vue?vue&type=script&lang=ts&"
export * from "./GradeSelector.vue?vue&type=script&lang=ts&"
import style0 from "./GradeSelector.vue?vue&type=style&index=0&id=6d5b1daf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5b1daf",
  null
  
)

export default component.exports